import React, { Component } from 'react';
import ReactDOM from 'react-dom';

import _ from 'lodash';

import moment from 'moment';
import momentDurationFormatSetup from "moment-duration-format";

momentDurationFormatSetup(moment);

import { DateRangePicker } from 'react-dates';

import 'react-dates/lib/css/_datepicker.css';

import utils from 'Utils/index.js';
import style from './style.scss';


export default class LeadsFilter extends Component {

  constructor(props) {
    super(props);

    const {app_data} = props;

    this.state = {
      start_date: moment().startOf('day'),
      end_date: moment().endOf('day'),
      device_type_id: 0,
      problem_type_id: 0,
      status_id: 0,
      model: '',
      phone: '',
      act_number: '',
      focusedInput: null
    };

    this.dateChange = this.dateChange.bind(this);
    this.deviceTypeChange = this.deviceTypeChange.bind(this);
    this.problemTypeChange = this.problemTypeChange.bind(this);
    this.statusChange = this.statusChange.bind(this);
    this.modelChange = this.modelChange.bind(this);
    this.phoneChange = this.phoneChange.bind(this);
    this.actNumberChange = this.actNumberChange.bind(this);

    this.onFilterChange = this.onFilterChange.bind(this);

  }

  dateChange({startDate, endDate}) {

    const start_date = startDate ? startDate.clone().startOf('day') : null;
    const end_date = endDate ? endDate.clone().endOf('day') : null;

    this.setState({
      start_date: start_date,
      end_date: end_date,
    });

  }

  deviceTypeChange(e) {

    this.setState({
      device_type_id: e.target.value
    });

  }


  problemTypeChange(e) {

    this.setState({
      problem_type_id: e.target.value
    });

  }

  statusChange(e) {

    this.setState({
      status_id: e.target.value
    });

  }

  modelChange(e) {
    this.setState({
      model: e.target.value
    });
  }

  phoneChange(e) {
    this.setState({
      phone: e.target.value
    });
  }

  actNumberChange(e) {
    this.setState({
      act_number: e.target.value
    });
  }

  onFilterChange() {
    const {onFilterChange} = this.props;

    onFilterChange(_.assign({}, this.state));
  }

  componentDidMount(){
    this.onFilterChange();
  }

  render() {
    let {app_data: {device_types, problem_types, statuses}, onFilter} = this.props;

    const ranges = [
      { id: 'today', range: { startDate: moment(), endDate: moment() }, label: 'Сегодня' },
      { id: '7_days', range: { startDate: moment().subtract(7, 'days'), endDate: moment() }, label: 'Последние 7 дней' },
      { id: '1_month', range: { startDate: moment().subtract(1, 'month'), endDate: moment() }, label: 'Последний месяц' },
      { id: '2_months', range: { startDate: moment().subtract(2, 'months'), endDate: moment() }, label: 'Последние 2 месяца' },
    ];

    const {start_date, end_date} = this.state;

    return (
      <div>

        <div className="leads_filter">

          <div className="leads_filter__row">

            <div className="layout__col_3">

              <div className="form__label">Дата</div>

              <div className="form__control">

                <DateRangePicker
                  startDate={start_date} // momentPropTypes.momentObj or null,
                  startDateId="start_date" // PropTypes.string.isRequired,
                  endDate={end_date} // momentPropTypes.momentObj or null,
                  endDateId="end_date" // PropTypes.string.isRequired,
                  onDatesChange={this.dateChange} // PropTypes.func.isRequired,
                  focusedInput={this.state.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                  onFocusChange={focusedInput => {
                    this.setState({ focusedInput })
                  }} // PropTypes.func.isRequired,
                  isOutsideRange={(date) => false /* allow future & past dates */}
                  minimumNights={0}
                />

              </div>

            </div>

            <div className="layout__col_3">

              <div className="form__label">Тип устройства</div>

              <div className="form__control">

                <select onChange={this.deviceTypeChange} value={this.state.device_type_id}>

                  <option value="0" key="0">Все типы</option>
                  <option value="-1" key="1000">Без типа</option>

                  {Object.keys(device_types).map(id => {
                    const device_type = device_types[id];
                    return <option value={id} key={id}>{device_type.title}</option>
                  })}

                </select>

              </div>

            </div>

            <div className="layout__col_3">

              <div className="form__label">Тип неисправности</div>

              <div className="form__control">

                <select onChange={this.problemTypeChange} value={this.state.problem_type_id}>

                  <option value="0" key="0">Все типы</option>

                  {Object.keys(problem_types).map(id => {
                    const problem_type = problem_types[id];
                    return <option value={id} key={id}>{problem_type.title}</option>
                  })}

                </select>

              </div>

            </div>


            <div className="layout__col_3">

              <div className="form__label">Статус</div>

              <div className="form__control">


                <select onChange={this.statusChange} value={this.state.status_id}>

                  <option value="0" key="0">Все статусы</option>

                  {Object.keys(statuses).map(id => {
                    const status = statuses[id];
                    return <option value={id} key={id}>{status.title}</option>
                  })}

                </select>

              </div>

            </div>




          </div>


          <div className="layout__row">


            <div className="layout__col_3">

              <div className="form__label">Бренд и модель</div>

              <div className="form__control">

                <input type="text" onChange={this.modelChange} value={this.state.model}/>

              </div>

            </div>

            <div className="layout__col_3">
              <div className="form__label">Телефон</div>
              <div className="form__control">
                <input type="text" onChange={this.phoneChange} value={this.state.phone}/>
              </div>
            </div>

            <div className="layout__col_3">
              <div className="form__label">Номер акта</div>
              <div className="form__control">
                <input type="text" onChange={this.actNumberChange} value={this.state.act_number}/>
              </div>
            </div>


            <div className="layout__col_3">
              <div className="button button_green button_big leads_filter__button" onClick={this.onFilterChange}>
                Применить
              </div>
            </div>

          </div>


        </div>



      </div>
    )
  }

}


